var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarrot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 32,
    viewBox: "0 0 15 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4537 0.0123396H8.86763H8.1077H4.18874C4.18874 0.0123396 0.576123 -0.383193 0.64376 3.30445C0.64376 3.30445 4.49907 23.145 6.55205 30.7121C6.55205 30.7121 6.72711 31.5191 7.80135 31.5791V31.5831C7.8093 31.5831 7.81726 31.5831 7.82522 31.5831C7.83318 31.5831 7.84113 31.5831 7.84909 31.5831V31.5791C8.91935 31.5191 9.09441 30.7121 9.09441 30.7121C11.1434 23.145 15.0027 3.30445 15.0027 3.30445C15.0664 -0.383193 11.4537 0.0123396 11.4537 0.0123396Z",
    fill: "#FD7701"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8292 0.0123396H4.18874C4.18874 0.0123396 0.576123 -0.383193 0.64376 3.30445C0.64376 3.30445 4.49907 23.145 6.55205 30.7121C6.55205 30.7121 6.72711 31.5191 7.80135 31.5791V31.5831C7.8093 31.5831 7.81726 31.5831 7.82522 31.5831C7.8292 31.5831 7.8292 31.5831 7.83318 31.5831V0.0123396H7.8292Z",
    fill: "#E54C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30917 10.3562H12.0982C12.313 10.3562 12.4921 10.1484 12.4921 9.89671C12.4921 9.64501 12.317 9.43726 12.0982 9.43726H9.30917C9.09432 9.43726 8.91528 9.64501 8.91528 9.89671C8.91528 10.1524 9.09432 10.3562 9.30917 10.3562Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4091 5.95346H12.8864C13.157 5.95346 13.3758 5.74571 13.3758 5.494C13.3758 5.2423 13.157 5.03455 12.8864 5.03455H9.4091C9.13856 5.03455 8.91973 5.2423 8.91973 5.494C8.91575 5.74571 9.13856 5.95346 9.4091 5.95346Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05862 14.7631H11.4538C11.5294 14.7631 11.593 14.6991 11.593 14.6232V13.988C11.593 13.9121 11.5294 13.8481 11.4538 13.8481H9.05862C8.98302 13.8481 8.91937 13.9121 8.91937 13.988V14.6232C8.91539 14.6991 8.97905 14.7631 9.05862 14.7631Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05862 19.1697H10.5387C10.6143 19.1697 10.6779 19.1058 10.6779 19.0298V18.3946C10.6779 18.3187 10.6143 18.2548 10.5387 18.2548H9.05862C8.98302 18.2548 8.91937 18.3187 8.91937 18.3946V19.0298C8.91539 19.1058 8.97905 19.1697 9.05862 19.1697Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05862 23.5765H9.65939C9.73499 23.5765 9.79865 23.5126 9.79865 23.4367V22.8015C9.79865 22.7255 9.73499 22.6616 9.65939 22.6616H9.05862C8.98302 22.6616 8.91937 22.7255 8.91937 22.8015V23.4367C8.91539 23.5126 8.97905 23.5765 9.05862 23.5765Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrot);
export default __webpack_public_path__ + "static/media/carrot.e5a0a58a9a0be894ffebeff45ea240b7.svg";
export { ForwardRef as ReactComponent };